import { render, staticRenderFns } from "./DownTimeOverview.vue?vue&type=template&id=def43df8"
import script from "./DownTimeOverview.vue?vue&type=script&lang=js"
export * from "./DownTimeOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports